export default "__VITE_ASSET__DsF01kWF__"